import React, {useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import useDataPost from "../../../hooks/useDataPost";
import {loadConnectAndInitialize, type StripeConnectInstance} from "@stripe/connect-js";
import {ConnectAccountOnboarding, ConnectComponentsProvider} from "@stripe/react-connect-js";
import Box from "@mui/material/Box";
import useDataFetch from "../../../hooks/useDataFetch";

interface StripeConnectCreateAccountResponse {
    accountId: string;
}

const StartStripeProcess = () => {

    const {
        data: retrievedConnectedAccountId,
        isLoading
    } = useDataFetch<string>('/stripe/connected-account/retrieve-connnected-account-id', true, true, false);

    const [connectedAccountId, setConnectedAccountId] = useState<string>();
    const [isStartingStripeAccountCreation, setIsStartingStripeAccountCreation] = useState(false);

    const {postDataPromise: createConnectedAccount} = useDataPost<StripeConnectCreateAccountResponse>('/stripe/connected-account/create-connected-account', {}, true, false, false);
    const {postDataPromise: retrieveSessionSecretForConnectedAccount} = useDataPost<string>('/stripe/connected-account/retrieve-session-secret-for-connected-account', {}, true, false, false);

    const [stripeConnectInstance, setStripeConnectInstance] = useState<StripeConnectInstance>();

    useEffect(() => {
        if (retrievedConnectedAccountId && !isLoading) {
            setConnectedAccountId(retrievedConnectedAccountId);
            retrieveSessionSecretForConnectedAccount(undefined, undefined).then((response) => {
                if (response.data) {
                    setStripeConnectInstance(loadConnectAndInitialize({
                        publishableKey: process.env.STRIPE_PUBLISHABLE_KEY || 'pk_live_51REejiGhFRYYnLQAt14IJt4WLhy8XSROBVd4j07gbw6BWUy7CjFJuJzdvuZCDrgTrDjbCHKUfjpHjOUcLgHQbgtL00PiGesccp',
                        fetchClientSecret: () => Promise.resolve(response.data),
                        locale: 'fr'
                    }))
                }
            })
        }
    }, [connectedAccountId, isLoading]);

    const handleStartStripeAccountCreation = () => {
        setIsStartingStripeAccountCreation(true);
        createConnectedAccount(undefined, undefined).then((response) => {
            setConnectedAccountId(response.data.accountId)
            retrieveSessionSecretForConnectedAccount(undefined, undefined).then((response) => {
                if (response.data) {
                    setStripeConnectInstance(loadConnectAndInitialize({
                        publishableKey: process.env.STRIPE_PUBLISHABLE_KEY || 'pk_live_51REejiGhFRYYnLQAt14IJt4WLhy8XSROBVd4j07gbw6BWUy7CjFJuJzdvuZCDrgTrDjbCHKUfjpHjOUcLgHQbgtL00PiGesccp',
                        fetchClientSecret: () => Promise.resolve(response.data),
                        locale: 'fr'
                    }))
                }
            })
        }).finally(() => {
            setIsStartingStripeAccountCreation(false);
        })
    }

    return (
        <Box p={4}>
            <Typography
                variant={"secondVariant"}
                sx={{
                    fontSize: {xs: 25, sm: 30}
                }}
            >
                Vérification d'identité
            </Typography>

            {!isLoading && !connectedAccountId && (
                <>
                    <Button
                        onClick={handleStartStripeAccountCreation}
                        variant={"firstVariant"}
                        sx={{
                            mt: 2,
                            mb: 4,
                        }}
                        disabled={isStartingStripeAccountCreation}
                    >
                        {isStartingStripeAccountCreation ? 'Chargement en cours ' : "Démarrer la vérification d'identité"}
                    </Button>
                </>
            )}

            {connectedAccountId && stripeConnectInstance && (
                <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                    <ConnectAccountOnboarding
                        onExit={() => {
                            console.log("The account has exited onboarding");
                        }}
                    />
                </ConnectComponentsProvider>
            )}

        </Box>
    );
}

export default StartStripeProcess
